import React from 'react';
import Promise from 'bluebird';
import Styled from 'styled';

import { HideForUnpaidVendor } from 'four-nets/vendor/permissions';

import ImageLikersButton from './image-likers-dialog/image-likers-button';
import LikeUnlikeButton from './like-unlike/like-unlike-image';

import { PhotoblogPostAlbumCommentsButtonsFragment } from '../buttons.graphql';
import defaultStyles from './image-likes-buttons.scss';

interface Props extends PhotoblogPostAlbumCommentsButtonsFragment {
    styles: typeof defaultStyles;
    inFeed?: boolean;
    inUi?: boolean;
}

interface State {
    isLikedByViewer: boolean;
    likesCount: number;
}

class ImageLikesButtons extends React.PureComponent<Props, State> {
    state = {
        isLikedByViewer: this.props.isLikedByViewer || false,
        likesCount: this.props.likesCount || 0,
    };

    promise: Promise<any> | null = null;

    componentDidUpdate(prevProps: Props) {
        if (prevProps.id !== this.props.id) {
            this.setState({
                isLikedByViewer: this.props.isLikedByViewer || false,
                likesCount: this.props.likesCount || 0,
            });
        }
    }

    like = (mutationFn: () => Promise<any>) => {
        this.setState(
            prevState => ({
                isLikedByViewer: !prevState.isLikedByViewer,
                likesCount: (prevState.likesCount || 0) + 1,
            }),
            () => {
                if (this.promise && this.promise.isPending()) {
                    this.promise.cancel();
                }

                this.promise = mutationFn()
                    .catch(this.likeDidFail)
                    .finally(() => {
                        this.promise = null;
                    });
            }
        );
    };

    unlike = (mutationFn: () => Promise<any>) => {
        this.setState(
            prevState => ({
                isLikedByViewer: !prevState.isLikedByViewer,
                likesCount: (prevState.likesCount || 1) - 1,
            }),
            () => {
                if (this.promise && this.promise.isPending()) {
                    this.promise.cancel();
                }

                this.promise = mutationFn()
                    .catch(this.unlikeDidFail)
                    .finally(() => {
                        this.promise = null;
                    });
            }
        );
    };

    likeDidFail = () => {
        this.setState(prevState => ({
            isLikedByViewer: false,
            likesCount: prevState.likesCount - 1,
        }));
    };

    unlikeDidFail = () => {
        this.setState(prevState => ({
            isLikedByViewer: true,
            likesCount: prevState.likesCount + 1,
        }));
    };

    render() {
        const { styles, inFeed, inUi, ...rest } = this.props;
        const { likesCount, isLikedByViewer } = this.state;

        const uiStyle = inUi ? { position: 'absolute', top: -45 } : {};

        return (
            <React.Fragment>
                <div className={styles.likersButton} style={uiStyle}>
                    <ImageLikersButton {...rest} likesCount={likesCount} />
                </div>
                <HideForUnpaidVendor style={{ relativeWrapper: styles.hideForUnpaidVendor }}>
                    <LikeUnlikeButton
                        {...rest}
                        isLikedByViewer={isLikedByViewer}
                        likesCount={likesCount}
                        like={this.like}
                        unlike={this.unlike}
                        inFeed={inFeed}
                    />
                </HideForUnpaidVendor>
            </React.Fragment>
        );
    }
}

export default Styled(defaultStyles)(ImageLikesButtons);
